import { client } from "../client/client";

export const getBranches = async () => {
  try {
    const response = await client.get("/branch");
    return response.data.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};
